import React from 'react';
import '../assets/style.css';
// import Footer from './Footer'; // Importing the Footer component


import instagramPost1 from '../assets/images/ACADEMYFORPUPPIES/InstagramPost1.webp';
import instagramPost2 from '../assets/images/ACADEMYFORPUPPIES/InstagramPost2.webp';
// import magazineMockup3 from '../assets/images/MAGAZINES/cmba magazine mockups 3.png';
// import flyerAd from '../assets/images/MAGAZINES/flyeer ad.png';
// import legalDirectory1 from '../assets/images/MAGAZINES/legal directory 1.png';
// import legalDirectory2 from '../assets/images/MAGAZINES/legal directory 2.png';

const AcademyforPuppies = () => {
  return (
    <div className="columns-1 p-3 md:p-10 m-5 md:m-10">
      {/* Rozi's Main Brand */}
      
      <main className="container mx-auto">
      <div className="mx-4 sm:mx-8 md:mx-16 lg:mx-52 xl:mx-52 2xl:mx-80 -mt-6 pt-6 sm:pt-5 md:pt-4 lg:pt-3 xl:pt-2 2xl:pt-0">
 {/* reduced from pt-32 md:pt-64 */}
  <h1
  className="text-center leading-tight md:leading-normal"
  style={{
    fontFamily: 'Bebas Neue',
    color: '#6ac9cb',
    fontSize: '3rem',
    textAlign: 'center',
  }}
>
  Academy for Puppies Brand Guide
</h1>



<p className="text-left text-gray-600 mb-5 md:mb-10 xl:mx-0 2xl:mb-14">
This project started as a fun trade! I created a full brand guide for Academy for Puppies 
in exchange for free dog training sessions. Working closely with the owner, I worked with an
existing logo and developed a fresh color palette and typography that captured the playful, curious spirit of puppies while keeping 
things clean and professional for the academy’s brand. The result is a warm, clean and friendly identity 
that feels both trustworthy and full of personality, just like the pups it represents while standing out from other dog training companies.

          </p>
    

        {/* Logo Video Presentation */}
        <div className="w-full max-w-full mx-auto h-auto overflow-hidden px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12">
  <div className="w-full max-w-screen-sm sm:max-w-screen-md md:max-w-screen-lg lg:max-w-screen-xl 2xl:max-w-[1400px] mx-auto">
    <h2 className="text-2xl sm:text-3xl md:text-2xl font-bold text-gray-800 mb-4 text-left">
      Academy for Puppies Brand Guide
    </h2>
    <iframe
  title="vimeo-player"
  src="https://player.vimeo.com/video/1131522556?h=4809bd09e4"
  className="w-full h-full sm:h-[400px] md:h-[200px] lg:h-[200px] lg:w[700px] xl:h-[300px] xl:w-[700px] 2xl:h-[600px]"
  frameBorder="0"
  referrerPolicy="strict-origin-when-cross-origin"
  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
  allowFullScreen
></iframe>

  </div>
</div>

<h2 className="text-2xl sm:text-3xl md:text-2xl font-bold text-gray-800 mb-4 mt-8 pl-12 text-left">
      Social Media Posts
    </h2>
    <div className="grid grid-cols-1 gap-8 mt-4 mb-6 place-items-center">
  {/* Paragraph */}
  <div className="w-full sm:w-[90%] md:w-[80%] xl:w-[100%]">
    <p className="text-left text-gray-600 mb-6 md:mb-10 2xl:mb-14 px-4 lg:px-0 leading-relaxed">
      I designed a series of Instagram posts to bring the Academy for Puppies brand to life online. 
      Each post mixed playful colors, cute puppy photos, and lighthearted typography to show off 
      the academy’s personality. The goal was to make the feed feel warm, fun, and consistent in 
      sharing training tips, happy client stories, and a bit of the everyday joy that comes with 
      working with puppies.
    </p>
  </div>

  {/* Images stacked single column on all screens */}
  <div className="grid grid-cols-1 gap-4 justify-items-center w-full max-w-[90%]">
    <img
      src={instagramPost1}
      alt="Instagram Post 1"
      className="w-full max-w-[500px] h-auto object-contain rounded-md shadow-md cursor-pointer"
    />
    <img
      src={instagramPost2}
      alt="Instagram Post 2"
      className="w-full max-w-[500px] h-auto object-contain rounded-md shadow-md cursor-pointer"
    />
  </div>
</div>





        </div>

      
      </main>
    </div>
  );
};

export default AcademyforPuppies;
